import { Mail, MessageSquare, Calendar, Forward, Trash2 } from 'lucide-react';

const AdminInquiries = ({ inquiries, onUpdateStatus, onReply, onForward, onDelete }) => {
  if (inquiries.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400" data-testid="admin-inquiries-empty">
        No contact inquiries yet
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="admin-inquiries">
      {inquiries.map((inquiry) => (
        <div
          key={inquiry.id}
          className="bg-black/40 backdrop-blur-sm rounded-xl p-6 border border-gray-700"
          data-testid={`admin-inquiry-${inquiry.id.slice(0, 8)}`}
        >
          <div className="flex justify-between items-start mb-4">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <h3 className="text-xl font-bold text-white">{inquiry.name}</h3>
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    inquiry.status === 'New'
                      ? 'bg-blue-500/20 text-blue-400'
                      : inquiry.status === 'In Progress'
                      ? 'bg-yellow-500/20 text-yellow-400'
                      : inquiry.status === 'Resolved'
                      ? 'bg-green-500/20 text-green-400'
                      : 'bg-gray-500/20 text-gray-400'
                  }`}
                >
                  {inquiry.status}
                </span>
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-400">
                <span className="flex items-center gap-1">
                  <Mail size={14} />
                  {inquiry.email}
                </span>
                <span className="flex items-center gap-1">
                  <Calendar size={14} />
                  {new Date(inquiry.created_at).toLocaleDateString()}
                </span>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h4 className="text-white font-semibold mb-1">Subject:</h4>
            <p className="text-gray-300">{inquiry.subject}</p>
          </div>

          <div className="mb-4">
            <h4 className="text-white font-semibold mb-1">Message:</h4>
            <p className="text-gray-300 whitespace-pre-wrap">{inquiry.message}</p>
          </div>

          {inquiry.admin_reply && (
            <div className="mb-4 p-4 bg-ewss-cyan/10 border border-ewss-cyan/30 rounded-lg">
              <h4 className="text-ewss-cyan font-semibold mb-1 flex items-center gap-2">
                <MessageSquare size={16} />
                Admin Reply:
              </h4>
              <p className="text-gray-300 whitespace-pre-wrap mb-2">{inquiry.admin_reply}</p>
              <p className="text-xs text-gray-400">
                Replied by {inquiry.replied_by} on{' '}
                {new Date(inquiry.replied_at).toLocaleString()}
              </p>
            </div>
          )}

          <div className="flex gap-3 flex-wrap">
            <select
              value={inquiry.status}
              onChange={(e) => onUpdateStatus(inquiry.id, e.target.value)}
              className="px-4 py-2 bg-ewss-navy border border-gray-600 rounded-lg text-white"
              data-testid={`admin-inquiry-status-select-${inquiry.id.slice(0, 8)}`}
            >
              <option value="New">New</option>
              <option value="In Progress">In Progress</option>
              <option value="Resolved">Resolved</option>
              <option value="Closed">Closed</option>
            </select>

            <button
              onClick={() => onForward(inquiry.id)}
              className="px-4 py-2 border-2 border-ewss-cyan text-ewss-cyan font-semibold rounded-lg hover:bg-ewss-cyan/10 transition-all duration-300 flex items-center gap-2"
              title="Forward to info@ewss.co.za"
              data-testid={`admin-inquiry-forward-${inquiry.id.slice(0, 8)}`}
            >
              <Forward size={18} />
              Forward
            </button>

            {!inquiry.admin_reply && (
              <button
                onClick={() => onReply(inquiry)}
                className="px-4 py-2 bg-ewss-cyan text-ewss-navy font-semibold rounded-lg hover:shadow-[0_0_20px_rgba(23,145,255,0.5)] transition-all duration-300 flex items-center gap-2"
                data-testid={`admin-inquiry-reply-${inquiry.id.slice(0, 8)}`}
              >
                <MessageSquare size={18} />
                Reply
              </button>
            )}

            <button
              onClick={() => onDelete(inquiry.id)}
              className="px-4 py-2 border-2 border-red-500 text-red-500 font-semibold rounded-lg hover:bg-red-500/10 transition-all duration-300 flex items-center gap-2"
              title="Delete inquiry"
              data-testid={`admin-inquiry-delete-${inquiry.id.slice(0, 8)}`}
            >
              <Trash2 size={18} />
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminInquiries;
